module.exports = __webpack_public_path__ + "img/18783678000153.93df8b6c.png";